export default __webpack_public_path__ + "static/SR USA - Liquid Caramel Color Lot Coding System - Statement-6cecc4ade05a81658538016af08b5e70.pdf";